<div class="body">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">input</mat-icon>
        <span>Vorgangsartikel in Vertrag übernehmen</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <ng-container *ngIf="(status|async) === TransformIssueItemsDialogComponentStatus.Ready">

            <mat-horizontal-stepper class="scrollable-inner-stepper" [selectedIndex]="currentIndex" (selectionChange)="stepperChanged($event)">

                <mat-step>
                    <ng-template matStepLabel>Artikel wählen</ng-template>
                    
                    <div @show class="inner-content">
    
                        <ng-container *ngFor="let item of items">
    
                            <div class="item-wrapper" (click)="toggleItem($event, item)">
                                <mat-checkbox [checked]="checked[item.itemid]" (click)="$event.preventDefault()"></mat-checkbox>
                                <div class="item-wrapper-content">
                                    <app-issue-item-label [item]="item"></app-issue-item-label>
                                </div>
                            </div>
    
                        </ng-container>
    
                    </div>
    
                </mat-step>
    
                <mat-step>
    
                    <ng-template matStepLabel>Vertrag wählen und Abschließen</ng-template>
                    
                    <div @show class="inner-content">
    
                        <ng-container *ngFor="let item of selectedItems">
    
                            <app-issue-item-contract-label 
                                [item]="item" 
                                [contracts]="contracts" 
                                [detailsExpanded]="true" 
                                (selectedContractChanged)="setItemContractMapping($event, item.itemid)"
                            ></app-issue-item-contract-label>
    
                        </ng-container>
    
                    </div>
    
                </mat-step>
                
            </mat-horizontal-stepper>

        </ng-container>

        <ng-container *ngIf="(status|async) === TransformIssueItemsDialogComponentStatus.NoContracts">

            <div class="error-hint">der Kunde hat keine Verträge</div>

        </ng-container>
        
        <ng-container *ngIf="(status|async) === TransformIssueItemsDialogComponentStatus.NoItems">

            <div class="error-hint">keine Vorgangsartikel</div>

        </ng-container>

    </div>

    <div class="footer">

        <div class="main-footer-content">

            <div class="counter" *ngIf="currentIndex === 0">
                {{selectedItemCounter}} von {{items? items.length: '0'}}
            </div>

        </div>
        <button mat-raised-button [disabled]="(status|async) !== TransformIssueItemsDialogComponentStatus.Ready || (currentIndex === 1 && !persistable)" (click)="next()">
            {{currentIndex === 1? 'Abschließen': 'Weiter'}}
        </button>

    </div>

</div>